import httpRequest from "./httpRequest"

const request = {
  // 查询协同育人
  getTionList: () => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/tion/list"),
      method: "get",
    })
  },
  // 合作案例
  getCollaborationList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/collaboration/list"),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 实习基地
  getBaseList: () => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/base/list"),
      method: "get",
    })
  },
  // 投稿须知
  getInstructions: () => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/info/one"),
      method: "get",
    })
  },
  // 编委
  getBoardList: () => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/board/list"),
      method: "get",
    })
  },
  // 期刊年期表
  getYearsIssue: () => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/submission/getYearsIssue"),
      method: "get",
    })
  },
  // 期刊列表
  getJournalList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/submission/list"),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 期刊详情
  getJournalDetails: (id) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/submission/${id}`),
      method: "get",
    })
  },
  // 在线投稿
  onlineSubmission: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/onlinesubmission/add"),
      method: "post",
      data: httpRequest.adornData(params),
    })
  },
  // 附件上传
  postUpload: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/common/upload`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询新闻列表 工控服务
  getInfoManageManageList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/infomanage/manage/list"),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询新闻列表
  getInfoManageList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/infoManage/list"),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据新闻id获取新闻详细信息 工控服务
  getNewInfoManageDetail: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(
        `/fApi/infoManage/${params.infoId}/${params.column}`
      ),
      method: "get",
      // params: httpRequest.adornParams(params),
    })
  },
  // 分页查询【商品】列表
  getProductList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/product/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询【商品】详情
  getProductById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/product/${params.productId}`),
      method: "get",
      // params: httpRequest.adornParams(params),
    })
  },
  // 分页查询【招标公告】列表
  getreportList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTender/page`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  //  根据招标id获取【招标公告】详细信息
  getreportdetail: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTender/${params.tenderId}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  //  分页查询【中标公告】列表
  getinfoTwList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTenderWinning/page`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  //  根据中标id获取【中标公告】详细信息
  getinfoTwDet: (params) => {
    // console.log(params)
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTenderWinning/${params.winningId}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取推荐【招标公告】信息
  postInfoTenderTop: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTender/top`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取推荐【中标公告】信息
  postInfoTenderWinningTop: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoTenderWinning/top`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取验证码
  getChaimg: () => {
    return httpRequest({
      url: httpRequest.adornUrl(`/captchaImage`),
      method: "get",
    })
  },
  // 用户提交留言信息
  postaddInfo: (data) => {
    return httpRequest({
      url: httpRequest.adornUrl("/fApi/online/add"),
      method: "post",
      data: httpRequest.adornData(data),
    })
  },
  // 查询业务联系信息列表
  getInfoBusinessContactList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/infoBusinessContact/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据id获取业务联系信息详细信息
  getInfoBusinessContactById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(
        `/fApi/infoBusinessContact/${params.contactId}`
      ),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 分页查询招聘管理列表
  getRecruitPage: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/recruit/page`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据id获取人才招聘详细信息
  getRecruitInfoById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/recruit/${params.contactId}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 分页查询企业信息列表
  getEnterprisePage: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/enterprise/page`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据id获取企业信息详细信息
  getEnterpriseById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/enterprise/${params.enterpriseId}`),
      method: "get",
      // params: httpRequest.adornParams(params)
    })
  },
  // 根据id获取企业信息详细拓展信息
  getEnterpriseExpand: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/professional/team/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取所有案例栏目
  getCaseColumn: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/case/column`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据栏目id 分页查询案例管理列表
  getCasePage: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/case/page`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据id获取案例详细信息
  getCaseById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/case/${params.caseId}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 分页查询广告管理列表
  getImageAdvertisingList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/imageAdvertising/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取广告管理详细信息
  getImageAdvertisingListById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(
        `/fApi/imageAdvertising/${params.advertisingId}`
      ),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  /*
                                    根据栏目类型分页查询图片管理列表
                                    */
  getImageManageList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/imageManage/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 根据id获取图片管理详细信息
  getImageManageListById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/imageManage/${params.imageId}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 分页查询栏目列表
  getImageManageColumnList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/imageManage/column`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 分页查询友情链接列表
  getFriendlyLinkList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/friendlyLink/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 获取友情链接详细信息
  getFriendlyLinkListById: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/friendlyLink/${params.id}`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 关于我们-查询公司简介页面所需信息
  getAboutusProfile: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/aboutus/enterprise/profile`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询关于我们-专业服务页面所需信息
  getAboutusProfessional: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/aboutus/professional/team`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询关于我们-查询大事记列表
  getAboutusMemorabiliaList: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/enterprise/memorabilia/list`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询关于我们-大事记页面所需信息
  getAboutusMemorabilia: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/aboutus/memorabilia`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询关于我们-企业文化页面所需信息
  getAboutusEnterpriseCulture: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/aboutus/enterprise/culture`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
  // 查询官网-服务领域页面所需信息
  getServiceTerritory: (params) => {
    return httpRequest({
      url: httpRequest.adornUrl(`/fApi/aboutus/service/territory`),
      method: "get",
      params: httpRequest.adornParams(params),
    })
  },
}
export default request
